import { Row, Col } from "antd";
import React from "react";

import Tool from "./Tool";

//LAPTOP
import switchNintendo from "../../images/tools/switch.jpg";
import playstation from "../../images/tools/playstation.jpg";

const Computer = props => {
  return (
    <React.Fragment>
      <Row gutter={16} style={{ marginBottom: 16 }}>
        <Col span={12}>
          <Tool
            title="Nintendo Switch"
            description="Black"
            link="https://www.nintendo.com/switch/"
            image={switchNintendo}
          />
        </Col>
        <Col span={12}>
          <Tool
            title="Playstation 4 Pro"
            description="Black"
            link="https://www.playstation.com/en-us/explore/ps4-pro/"
            image={playstation}
          />
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default Computer;



// WEBPACK FOOTER //
// ./src/components/Tools/Gaming.js